import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { Like } from '../like/like';
import { CommonProvider } from '../common'

/*
  Generated class for the PostProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PostProvider {
  private needsRefresh = new BehaviorSubject(false);
  currentRefreshStatus = this.needsRefresh.asObservable();


  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) {}

  private _url: string = this.commonProvider.apiUrl + 'api/v1/post';
  private _urlclub: string = this.commonProvider.apiUrl + 'api/v1/club';

  
  getAll(): Observable<Response<Post[]>> {
    return this.http.get<Response<Post[]>>(this._url + '/list');
  }

  getAllClub(id: string): Observable<Response<Post[]>> {
    return this.http.get<Response<Post[]>>(this._urlclub + `/${id}/post/list`);
  }

  getLatestOfUser(id: string): Observable<Response<Post[]>> {
    return this.http.get<Response<Post[]>>(this._url + `/list/user/${id}`);
  }

  get(id: string): Observable<Response<Post>> {
    return this.http.get<Response<Post>>(this._url + `/${id}/show`);
  }

  create(post: PostCreate): Observable<Response<Post>> {
    return this.http.post<Response<Post>>(this._url + `/create`, post);
  }

  createClub(id: string, post: PostCreate): Observable<Response<Post>> {
    return this.http.post<Response<Post>>(this._urlclub + `/${id}/post/create`, post);
  }

  delete(post: Post | string): Observable<Response<any>> {
    const id = typeof post == 'string' ? post : post.id;
    return this.http.post<Response<any>>(this._url + `/${id}/delete`, null);
  }
  
  doLike(post: Post | string): Observable<Response<Like>> {
    const id = typeof post == 'string' ? post : post.id;
    return this.http.post<Response<Like>>(this._url + `/${id}/like/create`, null);
  }
  
  getLikes(post: Post | string): Observable<Response<Like[]>> {
    const id = typeof post == 'string' ? post : post.id;
    return this.http.get<Response<Like[]>>(this._url + `/${id}/like/list`);
  }

  refreshStatus(status: boolean) {
    this.needsRefresh.next(status)
  }

}

export interface Post {
  id: string;
  company_id?: string;
  user_id?: string;
  club_id?: string;
  image_id?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

export interface PostCreate {
  image: string;
  content: string;
}


// WEBPACK FOOTER //
// ./src/providers/post/post.ts